import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getTelas = createAsyncThunk(
  "acessosApp/telas/getTelas",
  async (data: object, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/menu-tela", {
        params: data,
      });
    } catch (err: any) {
      dispatch(openModalError({
        title: "Não foi possível buscar as telas!",
        text: "Se certifique que os dados digitados estão corretos",
        btnLabel: "Voltar"
      }));
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const saveTela = createAsyncThunk(
  "acessosApp/telas/saveTela",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/menu-tela", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Tela cadastrada",
        })
      );
      dispatch(
        getTelas(
          requestGetParams.acessosApp.telas.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(openModalError({
        title: "Não foi possível cadastrar a tela!",
        text: "Se certifique que os dados digitados estão corretos",
        btnLabel: "Voltar"
      }));
      console.error(err.response);
    }
    return {};
  }
);

export const editTela = createAsyncThunk(
  "acessosApp/telas/editTela",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/menu-tela", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Tela editada",
        })
      );
      dispatch(
        getTelas(
          requestGetParams.acessosApp.telas.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(openModalError({
        title: "Não foi possível editar a tela!",
        text: "Se certifique que os dados digitados estão corretos",
        btnLabel: "Voltar"
      }));
      console.error(err.response);
    }
    return {};
  }
);

export const deleteTela = createAsyncThunk(
  "acessosApp/telas/deleteTela",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idTela } = data;
    try {
      await API.delete(`/menu-tela?id=${idTela}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Tela removida",
        })
      );
      dispatch(
        getTelas(
          requestGetParams.acessosApp.telas.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(openModalError({
        title: "Não foi possível remover a tela!",
        text: "Se certifique que a solicitação está correta",
        btnLabel: "Voltar"
      }));
      console.error(err.response);
    }
    return {};
  }
);
